/** @module Specification/DataPackageRefresh */
define([
	"dojo/_base/declare",
	"csi",
	"csi/_base/underscore",
	"./DataPackageReset"
], function(declare,csi,_,DataPackageReset) {

	return declare(DataPackageReset, {

		/**
		 * @override
		 *
		 * Display a confirmation dialog when one of the Data Sheets has ForProductSource attribute different from Data Package's ForProductSource attribute
		 */
		hasToConfirmAction: function() {
			var cache = this.getCache();
			var dataPackage = this.getNode();
			if (!dataPackage.ForProductSource || dataPackage.ForProductSource == csi.EMPTY_URL)
				return false;

			return _.some(dataPackage.DataSheets, function(dataPackageSheetURL) {
				var dataPackageSheet = cache.getNode(dataPackageSheetURL);
				if (!dataPackageSheet)
					return false;
				var dataSheetRevision = cache.getNode(dataPackageSheet.Sheet);
				if (!dataSheetRevision)
					return false;
				var dataSheet = cache.getNode(dataSheetRevision.__Parent__);
				if (!dataSheet)
					return false;
				return (dataSheet.ForProductSource && dataSheet.ForProductSource != csi.EMPTY_URL && dataSheet.ForProductSource != dataPackage.ForProductSource)
			});
		}
	});
});